import React, { Component } from "react";
import Cookies from 'js-cookie';
import Header from './Header'
import {getAccount, getTowers} from '../services/BinderDropService'
import {ShrinkNumber, AddRecent} from '../util/Helper'
import Logo_MarketCap from "../img/ico/round_policy.png"
import Logo_Sector from "../img/ico/round_sector.png"
import Logo_Ticker from "../img/ico/round_ticker.png"
import Logo_Industry from "../img/ico/round_industry.png"
import Tower from "../components/Tower";
import moment from "moment";
const queryString = require('query-string');


class AccountDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account:{},
      towers:[],
      activeTowerIndex:-1,
    };

    //document.title = "Home"
}

componentDidMount() {
  getAccount(this.props.id).then((account) => {
    this.setState({account});
    if(account.name){
      AddRecent({type:"ACCOUNT", id:this.props.id, name:account.name, imageUrl:account.imageUrl});
      getTowers(this.props.id, null, null).then((towers) => {
        if(towers && towers.length > 0){
          this.setState({towers, activeTowerIndex:towers.length > 1 ? -1 : 0});  
        }
      });
    }
  });
}



  render() {
    
    var _activeTower = this.state.towers[this.state.activeTowerIndex]; 

    //<span className="scValue">${ShrinkNumber(item.totalLimit)} Limit • ${ShrinkNumber(item.totalPremium)} Premium</span>
    return (
      <div>
        <Header showHero title={this.state.account.name}/>
        <a className="pillButton headerButton" href={"/benchmarking?sector="+this.state.account.sector+"&mincap="+(Math.round(this.state.account.marketCap*.8 / 1000000) * 1000000)+"&maxcap="+(Math.round(this.state.account.marketCap*1.2 / 1000000) * 1000000)+"&companyId="+this.state.account.companyId}>Benchmark Account</a>
        <div className="cardRow">
          <div className="card financeInfoCard">
            <img src={Logo_Industry}/>
            <span className="financeInfoCardTitle">Industry</span>
            <span className="financeInfoCardValue">{this.state.account.industry}</span>
          </div>
          <div className="card financeInfoCard">
            <img src={Logo_Sector}/>
            <span className="financeInfoCardTitle">Sector</span>
            <span className="financeInfoCardValue">{this.state.account.sector}</span>
          </div>
          <div className="card financeInfoCard">
            <img src={Logo_MarketCap}/>
            <span className="financeInfoCardTitle">Market Cap</span>
            <span className="financeInfoCardValue">${ShrinkNumber(this.state.account.marketCap)}</span>
          </div>
          <div className="card financeInfoCard">
            <img src={Logo_Ticker}/>
            <span className="financeInfoCardTitle">Symbol</span>
            <span className="financeInfoCardValue">{this.state.account.symbol}</span>
          </div>
        </div>
        
        {this.state.towers.length > 0 &&
          <>
            <label className="sectionTitle">Towers</label>
            <div className="cardRow scrollOutter">
              <div className="scrollInner">
              {this.state.towers.map((item, index) => {
                if(!item.policies?.length) return null;
                return <a className={"card selectCard" + (index === this.state.activeTowerIndex ? " active" : "")} onClick={()=>{this.setState({activeTowerIndex:index})}}>
                  <span className="scTitle">{item.product}</span>
                  <span className="scValue">{moment(item.effectiveDate).format('MMM YYYY')} - {moment(item.expirationDate).format('MMM YYYY')}</span>
                
                </a>
              })}
              </div>
            </div>
          </>
        }

        
        {_activeTower &&
        <>
          <label className="sectionTitle">Overview</label>
          <div className="cardRow">
            <div className="card infoCard">
              <span className="infocardTitle">Total Limit</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.totalLimit)}</span>
            </div>
            <div className="card infoCard">
              <span className="infocardTitle">Limit Split - ABC</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.abcLimit)}</span>
            </div>
            <div className="card infoCard">
              <span className="infocardTitle">Limit Split - A</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.sideALimit)}</span>
            </div>
            <div className="card infoCard">
              <span className="infocardTitle">Retention</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.retention)}</span>
            </div>
      
          </div>
          <div className="cardRow">
          <div className="card infoCard">
              <span className="infocardTitle">Total Premium</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.totalPremium)}</span>
            </div>
          <div className="card infoCard">
              <span className="infocardTitle">Premium / $1M</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.premiumPerMillion)}</span>
            </div>
            <div className="card infoCard">
              <span className="infocardTitle">Product Split - ABC</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.abcPremium)}</span>
            </div>
            <div className="card infoCard">
              <span className="infocardTitle">Product Split - A</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.sideAPremium)}</span>
            </div>
            <div className="card infoCard">
              <span className="infocardTitle">Total Commission</span>
              <span className="infocardValue">${ShrinkNumber(_activeTower.totalCommission)}</span>
            </div>
          </div>
        </>
        }
     
      {_activeTower &&
        <Tower tower={_activeTower}/>
      }
      </div>
      
    );
  }
}
 
export default AccountDetails;